// extracted by mini-css-extract-plugin
export default {"mainContainer":"containers_mainContainer__5SgCU","formContainer":"containers_formContainer__DN+fy","formContainerLarge":"containers_formContainerLarge__lw8Kr"};